export const truncateText = (text: string, maxLength = 50): string => {
    if (!text) return '';

    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
};

export const showTooltipForTruncatedText = (originalText: string, truncatedText: string): string => {
    if (!originalText || !truncatedText) return '';

    if (truncatedText.includes('...')) return originalText;
    return '';
};
